import React from "react";

const Projects = () =>
{
    return(
        <>
            <div className="d-flex justify-content-center">
                <h2 className="fw-bolder m-5">My Projects</h2>
            </div>

            <section className="Dark">
                <h5 className="fw-bold m-3 mt-5">E-Commerce Website</h5>
                <p className="p-2">An Ecommerce Shopping Website where user can See some items ,Add them to cart and purchase them</p>
                <p><strong>Tech Used : </strong> ReactJS | Redux | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <button className="darkBtn m-2 p-2">Live Project</button>
                    <button className="whiteBtn m-2 p-2">Source Code</button>
                </div>
            </section>

            <section className="White">
                <h5 className="fw-bold m-3 mt-5">Sales_CRM App (Zoho clone)</h5>
                <p className="p-2">CRM App to manage the issues of user , user can raise a issue ticket and track it.</p>
                <p><strong>Tech Used : </strong> ReactJS | Material UI | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="/" target='_blank' rel="noreferrer"><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="/"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>

            <section className="Dark">
                <h5 className="fw-bold m-3 mt-5">Login Form</h5>
                <p className="p-2">A Movie Booking App where user can see latest movies and Book Movie ticket according to them</p>
                <p ><strong>Tech Used : </strong> ReactJS | Redux | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="https://myloginform2.netlify.app/" target='_blank' rel="noreferrer"><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="https://github.com/Aishwarypatle/Login-form"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>

            <section className="White">
                <h5 className="fw-bold m-3 mt-5">Notes App</h5>
                <p className="p-2">A Simple Note App where anyone can write and store their Notes</p>
                <p><strong>Tech Used : </strong> ReactJS | Material UI | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="https://notesapp26.netlify.app/" target='_blank' rel="noreferrer"><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="https://github.com/Aishwarypatle/Notes-App"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>

            <section className="Dark">
                <h5 className="fw-bold m-3 mt-5">Books Recommender App</h5>
                <p className="p-2">Books Recommeding App where Application recommend Books to user according to genre</p>
                <p><strong>Tech Used : </strong> ReactJS | Bootstrap | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="https://books-recommender26.netlify.app/" target='_blank' rel="noreferrer"><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="https://github.com/Aishwarypatle/Books-Recommender"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>

            <section className="White">
                <h5 className="fw-bold m-3 mt-5">Emoji Interpreter</h5>
                <p className="p-2">A web app which solves your struggle with emojis. visit project to know about emojis</p>
                <p><strong>Tech Used : </strong> ReactJS | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="https://emoji-interpreter26.netlify.app/" target='_blank' rel="noreferrer" ><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="https://github.com/Aishwarypatle/Emoji-Interpreter"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>

            <section className="Dark">
                <h5 className="fw-bold m-3 mt-5">Palindrome Birthdate App</h5>
                <p className="p-2">A web app which tells that your birthdate is palindrome or nnot and nearest palindrome birthdate</p>
                <p><strong>Tech Used : </strong> Bootstrap | JavaScript | HTML | CSS</p>
                <div className="d-flex justify-content-center p-2">
                    <a href="https://notesapp26.netlify.app/" target='_blank' rel="noreferrer"><button className="darkBtn m-2 p-2">Live Project</button></a>
                    <a href="https://github.com/Aishwarypatle/Is-Your-Bday-Palindrome"><button className="whiteBtn m-2 p-2">Source Code</button></a>
                </div>
            </section>
            

        
        </>
    )
}


export default Projects